import {
  criticalityEnum,
  measureEnums,
  ontologyEnums,
  periodRangeTypeEnums,
  planOrderReportProcessDirectionEnums,
} from 'src/enums';
import { reduxPlanOrderReportProcessTypes } from 'src/types';
import {
  reduxExperimentationTypes,
  reduxOntologyTypes,
  reduxUserTypes,
  serviceOntologyTypes,
  servicePlanOrderReportProcessTypes,
  servicesUserTypes,
} from 'src/types';
import { OntologyTypeList } from 'src/types/redux/planOrderReportProcess.redux.type';
import { EventType, UserRoleType } from 'src/types/services/user-service.type';

export function getEnumKeyByValue<T extends Record<string, string>>(
  enumClass: T,
  enumValue: string | undefined,
): keyof T {
  if (enumValue === undefined || enumValue === null) {
    return '';
  }

  return Object.keys(enumClass).filter((key) => enumClass[key].toString() === enumValue.toString())[0];
}

export function getEnumKeyByValue2<T>(enumClass: T, enumValue: any): string {
  if (enumValue === undefined || enumValue === null) {
    return '';
  } else if (Object.keys(enumClass)[Object.values(enumClass).indexOf(enumValue)] === 'Player_Audience_Entity') {
    return 'Player/Audience_Entity';
  } else {
    return Object.keys(enumClass)[Object.values(enumClass).indexOf(enumValue)];
  }
}

export function getEnumSelectOptions<T>(enumClass: T): [string, any][] {
  return Object.entries(enumClass).filter((x) => Number.isNaN(parseInt(x[0], 10)));
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const filterNumberKeysFromEnum = <T extends any>(keys: T): T => {
  return (keys as Array<string>).filter((value: string) => Number.isNaN(Number(value))) as T;
};

export const convertUserServiceToRedux = (user: servicesUserTypes.User): reduxUserTypes.UserLoginInformation => {
  const uniqueRoles: UserRoleType[] = [];
  user.events.forEach((e) => {
    e.roles.forEach((role) => {
      if (!uniqueRoles.find((x) => x.id === role.id)) uniqueRoles.push(role);
    });
  });

  const convertedModuleForm: reduxUserTypes.UserLoginInformation = {
    id: user.id,
    userName: user.userName,
    email: user.email,
    name: user.name,
    surname: user.surname,
    // userRoleId: user.userRoleId.map(({ id, menu }) => ({ id, menu })),
    // userRoles: user.userRoles.map((obj) => ({ id: obj.id, menu: obj.menu })),
    isRegistered: user?.isRegistered,
    userRoles: uniqueRoles,
    events: user.events,
    sessionTime: user.sessionTime,
    isLocalUser: user.isLocalUser,
    preferredLanguage: user.preferredLanguage,
  };

  return convertedModuleForm;
};

export const convertPlanOrderReportProcessServiceToRedux = (
  planOrderReportProcess: servicePlanOrderReportProcessTypes.PlanOrderReportProcess,
): reduxPlanOrderReportProcessTypes.PlanOrderReportProcessInformation => {
  const convertedModuleForm: reduxPlanOrderReportProcessTypes.PlanOrderReportProcessInformation = {
    id: planOrderReportProcess.id,
    crisesId: planOrderReportProcess.crisesId,
    lineOfEffortId: planOrderReportProcess.lineOfEffortId,
    planOrderReportProcessNumber: planOrderReportProcess.planOrderReportProcessNumber,
    planOrderReportProcessName: planOrderReportProcess.planOrderReportProcessName,
    planOrderReportProcessTypeId: planOrderReportProcess.planOrderReportProcessTypeId,
    scriptedById: planOrderReportProcess.scriptedById,
    scriptedDateTime: planOrderReportProcess.scriptedDateTime,
    modifiedById: planOrderReportProcess.modifiedById,
    modifiedDateTime: planOrderReportProcess.modifiedDateTime,
    ownerEntityId: planOrderReportProcess.ownerEntityId,
    planOrderReportProcessDirection: planOrderReportProcess.planOrderReportProcessDirection,
    //Aynısı olacak buradaki getEnumKeyByValue Kalkacak
    receiverEntity: Array.isArray(planOrderReportProcess.receiverEntity)
      ? planOrderReportProcess.receiverEntity.map((obj) => {
          if (typeof obj === 'string') {
            return { abbreviation: '', id: obj };
          }
          return {
            abbreviation: obj.abbreviation,
            id: obj.id,
          };
        })
      : [],
    dateTimeGroup: planOrderReportProcess.dateTimeGroup,
    referenceId: planOrderReportProcess.referenceId,
    timeDetails: planOrderReportProcess.timeDetails,
    // quantity: planOrderReportProcess.quantity,
    // timeType: planOrderReportProcess.timeType,
    type: planOrderReportProcess.type,
    theMeanOfDelivery: planOrderReportProcess.theMeanOfDelivery.map((obj) => {
      if (typeof obj === 'string') {
        return { abbreviation: '', id: obj };
      }
      return {
        abbreviation: obj.abbreviation,
        id: obj.id,
      };
    }),
    description: planOrderReportProcess.description,
    log: planOrderReportProcess.log,
    comments: planOrderReportProcess.comments,
    statusId: planOrderReportProcess.statusId,
    attachments: planOrderReportProcess.attachments,
    isDecisionPoint: planOrderReportProcess.isDecisionPoint,
  };

  return convertedModuleForm;
};

// export const convertOntologyServiceToRedux = (
//   ontology: serviceOntologyTypes.Ontology,
// ): reduxOntologyTypes.OntologyInformation => {
//   const convertedModuleForm: reduxOntologyTypes.OntologyInformation = {
//     id: ontology.id,
//     ontologyType: getEnumKeyByValue2(ontologyEnums.OntologyEnum, ontology.ontologyType),
//     phrase: ontology.phrase,
//     abbreviation: ontology.abbreviation,
//     definition: ontology.definition,
//     // menu: getEnumKeyByNumberValue(menuEnums.MenuEnum, ontology.menu.toString()),
//     menu: ontology.menu,
//   };

//   return convertedModuleForm;
// };

export type EnumValues<T> = T[keyof T];
